// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__OuD17","logo":"MainNavigation_logo__u8TLJ","active":"MainNavigation_active__XfCoT","badge":"MainNavigation_badge__OeTvn"};